import moment from "moment";
import swal from "sweetalert";
import { NAME_REGEX } from "./RegexConstants";
export const validateEmail = (email) => {
  const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return pattern.test(email);
}

export const validateNumber = (number) => {
  const pattern = /^[0-9]*$/;
  return pattern.test(number);
}

export const validateAlphaNumeric = (string) => {
  const pattern = /^[a-zA-Z0-9 ]*$/;
  return pattern.test(string);
}

export const validateName = (name) => {
  const pattern = NAME_REGEX;
  return pattern.test(name);
}


export const checkValidData = (data) => {
  if (!data) return "Not Available";
  else return data;
}


export const calculateAge = (dateString) => {
  if (!dateString) {
    return "";
  }
  let a = moment();
  let b = moment(dateString);

  let years = a.diff(b, 'year');
  b.add(years, 'years');

  let months = a.diff(b, 'months');
  b.add(months, 'months');

  let days = a.diff(b, 'days');

 // console.log(years + ' years ' + months + ' months ' + days + ' days');
  let age = ((years?(years + ' years '): "") + (months ? (months + ' months ') : "")  + (days ?  (days + ' days'): ""));

  if(years === 0 && months === 0 && days === 0){
    age = "0 days";
  }
  return age;
}


export const getAuthToken = () => {
  let token = localStorage.getItem("USER_INFO") &&
    JSON.parse(localStorage.getItem("USER_INFO")) &&
    JSON.parse(localStorage.getItem("USER_INFO")).token;

  return token;
}

/**
 * This method will be called to format the table data for valid data.
 * @param {string} data of the table column.
 * @returns {string} data with first letter capital or Not available string
 */
export const firstLetterCapital = (data) => {
  if (!data) {
    return "Not Available";
  } else {
    return data.charAt(0).toUpperCase() + data.slice(1);
  }
};


export const isEmpty = (obj) => {
  let hasOwnProperty = Object.prototype.hasOwnProperty;
  // null and undefined are "empty"
  if (obj == null) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (let key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

export const dateFormatter = (cell) => {
  if (!cell) {
    return "";
  }
  return `${moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
    }`;
}

export const ageDifferenceInDays = (date) => {
  return moment().diff(date, 'days');
}
export const ageDifferenceInYears = (date) => {
  return moment().diff(date, 'years');
}

export const getFormattedBookedTime = (date, time) => {
  const dateTime = new Date(date);
  dateTime.setHours(time.split(":")[0]);
  dateTime.setMinutes(dateTime.getMinutes() + time.split(":")[1]);

  return dateTime
}

export const showAlert = (msg) => {
  swal(msg, {
    className: "logout-swal-modal",
    buttons: "ok",
  });
}

export const formatNumberToCurrency = (num) => {
  if (num === "" || num === null) {
    num = 0;
  }
  num = Number(num);
  let myObj = {
    style: "currency",
    currency: "ZAR"
  }
  let result = num.toLocaleString("en-US", myObj);
  result = result.replace("ZAR", "R");
  return result;
}


export const getValWithVAT = (price) => {
  let vat_percent = localStorage.getItem("SETTING_INFO") &&
    JSON.parse(localStorage.getItem("SETTING_INFO")).vat_percent;
  if (price || Number(price) > 0) {
    let vatPrice = (Number(price) * (vat_percent / 100));
    return (vatPrice + Number(price));
  }
  return 0;
}

export const getValueOfPercent = (price, percent) => {
  if (price || Number(price) > 0) {
    let finalValue = (Number(price) * (Number(percent) / 100));
    return finalValue ? finalValue : 0;
  }
  return 0;
}

export const isValEmpty = (val) => {
  if (val === null || val === "" || val === undefined) {
    return true
  } else {
    return false
  }
}